import { OverlayContainer } from '@angular/cdk/overlay';
import { AfterViewChecked, Component, OnInit, OnDestroy, DoCheck, Inject, ViewEncapsulation, ViewChild, ViewChildren, QueryList, ElementRef, ChangeDetectorRef, inject, DOCUMENT } from '@angular/core';
import { FormControl, FormGroup, UntypedFormControl } from '@angular/forms';
import { CdkDragDrop, moveItemInArray, CdkDropListGroup, transferArrayItem } from '@angular/cdk/drag-drop';
import { BsrService } from './bsr.service';
// import { HotkeysService, Hotkey } from 'angular2-hotkeys';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

//import { BsrService } from './services/bsr.service';
import { HISTORY_BOOK_STORE } from '../signals/+store/history-book.store';
import { HistoryBook } from '../signals/+models/history-book.model';
import { SlideTextService } from './services/slide-text.service';

/** One word in the PDF Invisible Mode text layer. */
interface PdfInvWord {
  text: string;
  leftPct: number;
  topPct: number;
  /** Word width as a fraction of the image's natural width (for scaleX). */
  targetWidthFrac: number;
  /** Unscaled rendered width in px, measured once. */
  baseWidthPx: number;
}

@Component({
    selector: 'app-bsr',
    templateUrl: './bsr.component.html',
    styleUrls: ['./bsr.component.scss'],
    standalone: false
})
export class BsrComponent implements OnInit, DoCheck, AfterViewChecked, OnDestroy {

  @ViewChild('slider') slider;
  postItListTheme = 'post-it-list-theme'
  searchBoxLeftProperty = '611px;'
  font_size = '30';
  font_size_text = this.font_size + 'px';
  diplayFontSizeSlider = false;
  loginForm: UntypedFormGroup;
  isMouseOver: boolean = false;
  sliderVal = 51;
  totalNumberOfnames = 51;
  slideCss = 'none';
  // projectId = 'rg2327';
  projectId = 'te2687';
  projectName = 'te2687';
  createPostIt = false;
  isDeleteButon = false;
  isSearching = false;
  search: any;
  overview = false;
  isNSR = false;
  isScreenButton = true;
  isScreeningNames = false;
  slideBackground = 'url(http://www.bipresents.com/';
  baseBackgroundUrl = 'url(http://www.bipresents.com/';
  myControl = new UntypedFormControl();
  options: string[] = ['One', 'Two', 'Three'];
  totalNumberOfSlides: any;
  pageCounter = '';
  currentPageNumber = 0;
  appSlidesData: any;
  mainMenu: boolean = true;
  conceptData: any = [];
  newPost: Object;
  newName: any;
  conceptid: any;
  deletePost: Object;
  nameCandidates: any = [];
  nameBox = true;
  nameBoxB = true;
  myMaxWith = '1080px';
  myMaxWith2: any;
  myMaxRWith = '900px';
  myMaxRightWith = '8px';
  showSlider: boolean = false;
  postItPresentationIndex: number;
  appSearchSlidesData: any = [];
  slideBackground2: string;
  nameIndexCounter = 0;
  isCommentBox: boolean = false;
  commentBoxText = "";
  elem: any;
  isFullscreen = false;
  namesBoxIndexValue = 30;
  namesBoxIndex = 1;
  wideScreen = false;
  BackgroundUrl = 'http://bipresents.com/nw2/';
  BackgroundUrlOff = 'url(http://bipresents.com/nw2/assets/images/BackGrounds/Backgrounds2019/';
  baseUrl: any;
  restUrl: any;
  open: boolean = false;
  wide = true
  showHotKeys = false
  showDialog = false
  clickBlocked = false;
  loader = false;
  history: boolean = false;
  private readonly historyBookStore = inject(HISTORY_BOOK_STORE);

  // --- PDF Invisible Mode: auto-applied invisible selectable OCR text layer ---
  private readonly slideText = inject(SlideTextService);
  @ViewChild('pdfLayer') private pdfLayerRef?: ElementRef<HTMLElement>;
  @ViewChildren('iword') private iwordRefs?: QueryList<ElementRef<HTMLElement>>;
  /** Slide image host (same one used for the background). */
  private readonly OCR_IMAGE_BASE = 'http://www.bipresents.com/';
  /** Displayed slide height in px (.slide-box / .slide-box-width are 679px tall). */
  private readonly PDF_LAYER_HEIGHT_PX = 679;
  /** Feature flag: when true, each image slide gets the invisible text layer. */
  pdfInvisibleMode = true;
  pdfLines: Array<{ fontPx: number; words: PdfInvWord[] }> = [];
  private pdfFlatWords: PdfInvWord[] = [];
  private pdfNeedsMeasure = false;
  private pdfResizeObs: ResizeObserver | null = null;
  /** Increments per run so a stale OCR result (fast navigation) is never applied. */
  private pdfRequestId = 0;
  /** Tracks slideBackground to auto-trigger OCR when the visible slide changes. */
  private lastSlideBackgroundForOcr = '';

  constructor(@Inject(DOCUMENT) private document: any,
    private cdr: ChangeDetectorRef, private _BsrService: BsrService, public dialog: MatDialog, private activatedRoute: ActivatedRoute, public _snackBar: MatSnackBar,

    // private _hotkeysService: HotkeysService,
  ) {


  }

  ngOnInit(): void {
    const storedName = localStorage.getItem('userName');

    if (!storedName) {
      this.showDialog = true
    } else {
      this.showDialog = false
    }
    this.toggleNamebox()
    this.baseUrl = this._BsrService.getBaseUrlForResources();
    window.addEventListener('keydown', this.handleKeyDown.bind(this));
    if (this.baseUrl === 'https://bitools.s3.amazonaws.com/nw-resources/') {
      this.BackgroundUrl = 'https://d3lyn5npnikbck.cloudfront.net/'
    }


    this.font_size_text = (localStorage.getItem(this.projectName + '_font_size_text')) ? localStorage.getItem(this.projectName + '_font_size_text') : '26px';
    this.font_size = (localStorage.getItem(this.projectName + '_font_size')) ? localStorage.getItem(this.projectName + '_font_size') : '26';
    this.activatedRoute.params.subscribe(params => {

      // set project ID as localstorage identifier 03/16/21
      this.projectName = params['id'];
      this._BsrService.setProjectName(this.projectName);
      localStorage.setItem(this.projectName + '_projectId', this.projectName);
      localStorage.setItem(this.projectName + '_projectName', this.projectName);
      this.projectId = this.projectName;
      this.historyBookStore.setCurrentProjectId(this.projectId);
    });

    this.assignCopy();
    this.elem = document.documentElement;

    this.postItListTheme = localStorage.getItem(this.projectName + '_post-it-list-theme');
    this._BsrService.getSlides(this.projectId).subscribe((res: any) => {
      this.appSlidesData = res;
      // this.appSearchSlidesData = res;
      localStorage.setItem(this.projectName + '_appSlideData', JSON.stringify(res));
      this.totalNumberOfSlides = res.length;
      this.pageCounter = '1/' + (parseInt(this.totalNumberOfSlides));
      let slideRes = res[0].SlideBGFileName
      this.wide = res[0].isWide != null ? true : false
      this.slideBackground = this.slideBackground + slideRes + ')';
      this.appSlidesData.forEach(element => {
        if (element.SlideType === "NameSummary") {
          this.postItPresentationIndex = parseInt(element.$id) - 1;
        }
      });
      this.createPostIt = false;
      if (this.createPostIt) {
        this.searchBoxLeftProperty = '777px';
        this.currentPageNumber = (this.createPostIt) ? this.appSlidesData[0].SummarySlide - 1 : 0;
        this.pageCounter = (this.createPostIt) ? this.appSlidesData[0].SummarySlide + '/' + (parseInt(this.totalNumberOfSlides)) : '1/' + (parseInt(this.totalNumberOfSlides));
      } else {
        this.searchBoxLeftProperty = '611px;';
        this.currentPageNumber = 0;

      }
    })

    this._BsrService.getPost().subscribe((res: any) => {
      this.conceptData = JSON.parse(res[0].bsrData);

      if (JSON.parse(res[0].bsrData).presentationtype === 'NSR') {
        this.isNSR = true;
      }

      this.conceptData.concepts.forEach(element => {
        element.concept = element.concept.replace(/`/g, "'");
        element.html = element.html.replace(/`/g, "'");
      });
    });


    setInterval(() => {
      this._BsrService.getNameCandidates(this.projectId).subscribe((res: any) => {
        res.forEach(name => {
          name.html = name.html.replace(/\\/g, '');
        });
        this.nameCandidates = (res.length > 0) ? res : [];
      });
    }, 10000);


    this.getCommentsByIndex(0);
    this.loginForm = new FormGroup({
      rationale: new FormControl(""),
      suma: new FormControl(""),
      name: new FormControl("")
    });
    this.nameIndexCounter = (localStorage.getItem(this.projectName + '_namesIndexCounte')) ? parseInt(localStorage.getItem(this.projectName + '_namesIndexCounte')) : 0;


    this.onInputChange(parseInt(localStorage.getItem(this.projectName + '_namesBoxIndex')));
    this.currentPageNumber = 1;
  }


  promptForName(name) {
    if (name) {
      localStorage.setItem('userName', name);
      this.showDialog = false
      return true
    } else {
      this.showDialog = true 
      return false
    }
  }


  getCommentsByIndex(index) {
    this._BsrService.getComments(index).subscribe((arg: any) => {
      if (!arg || arg.length === 0) {
        this.commentBoxText = '';
        return;
      }

      let response = arg;

      if (typeof response === 'string') {
        try {
          const parsedData = JSON.parse(response);
          this.commentBoxText = parsedData[0]?.Comments || '';
        } catch (error) {
          console.error('Error parsing comment data:', error);
          this.commentBoxText = '';
        }
      } else {
        response = arg[0];
        this.commentBoxText = response.Comments;
      }
    });
  }
  wideScreenView() {
    this.wide = !this.wide
  }

  boxWidth = 155;
  // calculated based on dynamic row width
  columnSize: number;

  getItemsTable(rowLayout: Element): number[][] {
    // calculate column size per row
    const { width } = rowLayout.getBoundingClientRect();
    const columnSize = Math.round(width / this.boxWidth);
    // view has been resized? => update table with new column size
    if (columnSize != this.columnSize) {
      this.columnSize = columnSize;
      this.initTable();
    }
    this.conceptData.concepts.forEach(element => {
      element.concept = element.concept.replace(/`/g, "'");
      element.html = element.html.replace(/`/g, "'");
    });
    return this.conceptData.concepts;
  }

  initTable() {
    // create table rows based on input list
    // example: [1,2,3,4,5,6] => [ [1,2,3], [4,5,6] ]
    this.conceptData.concepts = this.conceptData.concepts
      .filter((_, outerIndex) => outerIndex % this.columnSize == 0) // create outter list of rows
      .map((
        _,
        rowIndex // fill each row from...
      ) =>
        this.conceptData.concepts.slice(
          rowIndex * this.columnSize, // ... row start and
          rowIndex * this.columnSize + this.columnSize // ...row end
        )
      );
  }

  reorderDroppedItem(event: CdkDragDrop<number[]>) {
    // same row/container? => move item in same row
    if (event.previousContainer === event.container) {

      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      // different rows? => transfer item from one to another list
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }

    // update items after drop: flatten matrix into list
    // example: [ [1,2,3], [4,5,6] ] => [1,2,3,4,5,6]
    this.conceptData.concepts = this.conceptData.concepts.reduce(
      (previous, current) => previous.concat(current),
      []
    );

    // re-initialize table - makes sure each row has same numbers of entries
    // example: [ [1,2], [3,4,5,6] ] => [ [1,2,3], [4,5,6] ]
    this.initTable();
  }

  orderArray(orderArray) {


    const orderIds = orderArray.concepts.map((element) => element.conceptid);

    const uniqueOrderIds = [...new Set(orderIds)];

    //if (this.clickBlocked) return;



    this._BsrService.postItOrder(this.projectId, uniqueOrderIds).subscribe(arg => {
      this.clickBlocked = true;
      this._BsrService.getPost().subscribe((res: any) => {
        this.conceptData = JSON.parse(res[0].bsrData);
        this.cdr.detectChanges();
        if (this.conceptData.presentationtype === 'NSR') {
          this.isNSR = true;
          this.clickBlocked = false;
        }



      }, (error) => {
        console.error('Error al obtener los ítems:', error);
        this.clickBlocked = false;
      });
    }, (error) => {
      console.error('Error al subir el cambio:', error);
      this.clickBlocked = false;
    });
  }
  trackByFn(index, item) {
    return item.conceptid;
  }


  onPostItDrop(event: CdkDragDrop<any[]>) {
    if (this.clickBlocked || !this.conceptData?.concepts) {
      return;
    }

    if (event.previousIndex === event.currentIndex) {
      return;
    }

    moveItemInArray(this.conceptData.concepts, event.previousIndex, event.currentIndex);
    this.conceptData = {
      ...this.conceptData,
      concepts: [...this.conceptData.concepts],
    };
    this.cdr.detectChanges();
    this.orderArray(this.conceptData);
  }


  // TOOLBAR MENU ACTIONS
  moveForward() {
    this.searchBoxLeftProperty = '611px;';
    this.appSearchSlidesData = [];
    this.isCommentBox = false;
    this.createPostIt = false;
    if (this.totalNumberOfSlides > this.currentPageNumber + 1) {
      this.currentPageNumber = 1 + this.currentPageNumber;
      this.slideBackground = this.baseBackgroundUrl + this.appSlidesData[this.currentPageNumber].SlideBGFileName + ')';
      if (this.postItPresentationIndex === this.currentPageNumber) {
        this.createPostIt = true;
        this.searchBoxLeftProperty = '777px';
        this.bsr();
      }
      this.pageCounter = this.currentPageNumber + 1 + '/' + this.totalNumberOfSlides;
      if (this.currentPageNumber + 1 == this.appSlidesData[this.currentPageNumber].SummarySlide) {
        this.bsr()
      } else {
        this.createPostIt = false;

      }
    } else {
      this.goToSlide(this.currentPageNumber);
    }
  }


  moveBackward() {
    this.searchBoxLeftProperty = '611px;';
    this.appSearchSlidesData = [];
    this.isCommentBox = false;
    this.createPostIt = false
    if (this.currentPageNumber >= 1) {
      this.currentPageNumber = this.currentPageNumber - 1;
      this.pageCounter = this.currentPageNumber + 1 + '/' + this.totalNumberOfSlides;
      this.slideBackground = this.baseBackgroundUrl + this.appSlidesData[this.currentPageNumber].SlideBGFileName + ')';
      if (this.postItPresentationIndex === this.currentPageNumber) {
        this.createPostIt = true;
        this.searchBoxLeftProperty = '777px';
        this.bsr();
      }
      if (this.currentPageNumber + 1 == this.appSlidesData[this.currentPageNumber].SummarySlide) {

        this.bsr()
      } else {
        this.createPostIt = false;
      }
    }
  }

  showHistory() {
    this.history = !this.history
  }

  handleKeyDown(event: KeyboardEvent): void {
    const focusedElement = document.activeElement as HTMLElement;
    if (focusedElement && focusedElement.id === 'mat-input-0') {
      return;
    }
    if (!this.open && !this.isCommentBox) {
      if (event.key === 'ArrowUp') {
        this.mainMenu = true
      } else if (event.key === 'ArrowDown') {
        this.mainMenu = false
      }

      else if (event.key === 'ArrowRight') {
        this.moveForward();
      } else if (event.key === 'ArrowLeft') {
        this.moveBackward();
      } else if (event.shiftKey && event.altKey && (event.key === 'o' || event.key === 'O')) {
        this.overview = !this.overview;
      } else if ((event.key === 'b' || event.key === 'B') && event.ctrlKey) {

        if (!this.createPostIt) {
          this.bsr()
        } else {
          this.home()
        }

      } else if (event.key === 'Escape') {
        this.showHotKeys = false
      } else if (event.altKey && event.key === 'h') { 
        if(this.createPostIt){
          this.showHistory();
        }
      }
    }
  }
  changeUser() {
    this.showDialog = true
  }
  submitNewName() {
    const item = {
      concept: '',
      html: '',
      names: this.loginForm.value.name.split(',').map((name: string) => name)
    }
    this.addToHistory('Add New Names', item);
    this.loginForm.value.name.split(',').forEach(element => {
      const userName = localStorage.getItem('userName')
      this._BsrService.sendNewName(element, userName, this.isNSR).subscribe(arg => {
      });
    });
    setTimeout(() => {
      this._BsrService.getNameCandidates(this.projectId).subscribe((res: any) => {
        this.nameCandidates = res;
      });
    }, 300);
  }

  newBlankPostIt() {
    let newConcepData = {
      projectId: this.projectId,
      conceptid: '0',
      concept: 'Concept',
      conceptorder: '0',
      attributes: [],
      names: []
    }
    this.addToHistory('New Post', newConcepData);
    this._BsrService.newPost(JSON.stringify(newConcepData)).subscribe(arg => {
      this._BsrService.getPost().subscribe((res: any) => {
        this.conceptData = JSON.parse(res[0].bsrData);
        this.conceptData.concepts.forEach(element => {
          element.concept = element.concept.replace(/`/g, "'");
          element.html = element.html.replace(/`/g, "'");
        });
      });
    });
  }

  sideMenu() {
    this.overview = !this.overview;
  }

  home() {
    this.searchBoxLeftProperty = '611px;';
    this.pageCounter = '1/' + this.totalNumberOfSlides;
    this.slideBackground = this.baseBackgroundUrl + this.appSlidesData[0].SlideBGFileName + ')';
    this.createPostIt = false;
    this.currentPageNumber = 0;
    localStorage.setItem(this.projectName + '_namesIndexCounte', '0');
    localStorage.setItem(this.projectName + '_createPostIt', 'false');
  }

  bsr() {
    // reset search data
    this.appSearchSlidesData = [];
    this.mainMenu = false;
    this.createPostIt = !this.createPostIt;
    if (this.createPostIt) {
      this.searchBoxLeftProperty = '777px';
    } else {
      this.searchBoxLeftProperty = '611px;';
    }

    localStorage.setItem(this.projectName + '_createPostIt', this.createPostIt.toString());
    this.nameIndexCounter = parseInt(localStorage.getItem(this.projectName + '_namesIndexCounte'));
    this.onInputChange(parseInt(localStorage.getItem(this.projectName + '_namesBoxIndex')));

  }

  displayCommentBox() {
    this.isCommentBox = !this.isCommentBox;
    (this.isCommentBox) ? this.getCommentsByIndex(this.currentPageNumber) : null;
  }

  comment() {

    if (this.isCommentBox) {

      let comment = this.projectId + "','" + this.currentPageNumber + "',N'" + this.commentBoxText + "'";

      this._BsrService.sendComment(comment).subscribe((res: any) => {
        let newConcepData = {
          projectId: this.projectId,
          conceptid: '-1',
          concept: 'Concept',
          conceptorder: '0',
          attributes: [],
          names: []
        }
        console.log(comment)

        this._BsrService.newPost(JSON.stringify(newConcepData)).subscribe((arg: any) => {
          if (typeof arg[0] === 'string') {

            this.conceptData = JSON.parse(JSON.parse(arg)[0].bsrData);
          } else {
            this.conceptData = JSON.parse((arg)[0].bsrData);
          }
          let summayConceptId = '';
          this.conceptData.concepts.forEach(element => {
            if (element.concept === "SUMMARY" || element.concept === "summary") {
              summayConceptId = element.conceptid
            }
          });

          // SUMMIRIZE COMMENTS INTO A POST IT
          let comments = '';
          console.log(res)
          if (typeof res === 'string') {
            if (res) {
              res = JSON.parse(res)
            } else {
              res = []

            }
          }
          res.forEach(element => {
            comments += "<p>" + element.Comments + "<p>"
          });


          let newConcepData2 = {
            projectId: this.projectId,
            concept: 'SUMMARY',
            conceptid: '"' + summayConceptId + '"',
            attributesArray: '',
            namesArray: '',
            conceptHtml: comments
          }
          const userName = localStorage.getItem('userName')
          this._BsrService.updatePost(JSON.stringify(newConcepData2), userName)
            .subscribe(arg => {

              this._BsrService.getPost().subscribe((res: any) => {
                this.conceptData = JSON.parse(res[0].bsrData);
                // this.conceptData.concepts[0].html = this.commentBoxText;
                this.conceptData.concepts.forEach(element => {
                  element.concept = element.concept.replace(/`/g, "'");
                  element.html = element.html.replace(/`/g, "'");
                });
                this.isCommentBox = false;
                this.commentBoxText = '';
              });

            });

        });

      });
    }
  }

  displayHelp(display: boolean) {
    // (display) ? this._hotkeysService.cheatSheetToggle.next() : this._hotkeysService.cheatSheetToggle.next(display);
    // this._hotkeysService.cheatSheetToggle.next(true)
  }

  goToSlide(i) {
    this.overview = false;
    this.currentPageNumber = i;


    if (this.postItPresentationIndex == this.currentPageNumber) {
      this.createPostIt = true;

    } else {
      if (i) {
        let slideBG = this.appSlidesData[i].SlideBGFileName;
        this.slideBackground = this.baseBackgroundUrl + slideBG + ')';
      }

      this.createPostIt = false;
    }


    this.pageCounter = i + 1 + '/' + this.totalNumberOfSlides;
  }

  goToSlideFromSearch(i: string) {
    const ii = parseInt(i) - 1;
    this.slideBackground = this.baseBackgroundUrl + this.appSlidesData[ii].SlideBGFileName + ')';
    this.createPostIt = false;
    this.pageCounter = ii + 1 + '/' + this.totalNumberOfSlides;
  }
  
  hasChanges(original: any, updated: any): boolean {
    if (!original || !updated) return false;
  
    for (const key in original) {
      if (original.hasOwnProperty(key) && updated.hasOwnProperty(key)) {
        if (JSON.stringify(original[key]) !== JSON.stringify(updated[key])) {
          return true;
        }
      }
    }
  
    return false;
  }  

  addToHistory(action: string, item: any) {
    const historyData: HistoryBook = {
        date: new Date().toLocaleDateString(),
        time: new Date().toLocaleTimeString(),
        action: action,
        content: JSON.stringify({
            'Concept Title': item.concept || '',
            'Key Words and Concepts': item.html || '',
            'New Names': item.names || [],
        }),
    };
    this.historyBookStore.addHistory(historyData, this.projectId);
  }

  openDialog(item, nameid) {
    this.open = true;
    this.clickBlocked = true;
    const dialogRef = this.dialog.open(editPost, {
      // width: ((nameid === 'edit')?'80%':'100%'),
      // height: ((nameid === 'edit') ? '777px' : '200px'),
      data: {
        name: item,
        nameId: nameid
      },
      disableClose: true
    });
    this.conceptid = item.conceptid;

    dialogRef.backdropClick().subscribe(() => {
      const editPostInstance = dialogRef.componentInstance;
      if (editPostInstance.loginForm.dirty || (editPostInstance.model.editorData !== item.html)) {
        editPostInstance.buttonOption('savePost');
      } else {
        dialogRef.close({ option: 'cancel' });
      }
    });

    dialogRef.afterClosed().subscribe((result: { option: string, item?: any }) => {
      this.open = false;
      this.loader = false;
      this.clickBlocked = false;
      if (!result) return;
      
      if (result && result.option !== 'cancel' ) {
        this.loader = true
        const itemModified = result?.item;
        item.names = item.names?.map((name: any) => name?.name) || [];
        setTimeout(() => {

          this.open = false;
          this.conceptData.concepts.forEach(element => {
            element.concept = element.concept.replace(/`/g, "'");
            element.html = element.html.replace(/`/g, "'");
          });

          if (result.option === 'delete') {
            if (this.conceptid === '-1') {
              this.conceptid = "'" + -1 + '"';
            }
            this.addToHistory('Delete Post', item);
            this._BsrService.deletePost(this.conceptid).subscribe(arg => {
              this._BsrService.getPost().subscribe(res => {
                this.conceptData = JSON.parse(res[0].bsrData);
                this.conceptData.concepts.forEach(element => {
                  element.concept = element.concept.replace(/`/g, "'");
                  element.html = element.html.replace(/`/g, "'");
                });
                this.loader = false;
                },
                error => {
                  this.loader = false
                  
                });
              });
          } else if (result.option === 'deleteName') {
            item.names = item.Name ? [item.Name] : [];
            this.addToHistory('Delete Name', item);
            this._BsrService.getNameCandidates(this.projectId).subscribe(res => {
              this.nameCandidates = res;
              this.loader = false;
            });
          } else if (result.option === 'savePost' && itemModified) {
            if (this.hasChanges(item, itemModified)) {
              this.addToHistory('Edit Post', itemModified);
            }
            this._BsrService.getPost().subscribe(
              res => {
                this.conceptData = JSON.parse(res[0].bsrData);
                this.conceptData.concepts.forEach(element => {
                  element.concept = element.concept.replace(/`/g, "'");
                  element.html = element.html.replace(/`/g, "'");
                });
                if (JSON.parse(res[0].bsrData).presentationtype === 'NSR') {
                  this.isNSR = true;
                }
                this.loader = false
                this._snackBar.open('Data was saved', 'OK', {
                  duration: 5000,
                  horizontalPosition: 'right',
                  verticalPosition: 'top'
                });
              },
              error => {
                this.loader = false
                this._snackBar.open('There was an error saving data', 'OK', {
                  duration: 5000,
                  horizontalPosition: 'right',
                  verticalPosition: 'top'
                });

              });
          } else {
            this.open = false;
            this.loader = false;
            this.clickBlocked = false;
          }
          this._BsrService.getNameCandidates(this.projectId).subscribe({

            next: (response: any) => {
              this.nameCandidates = response
            },
            error: (error) => {
              console.log("cant get namecadidates")
            },

          });
        }, 500);
      }
    });
  }

  assignCopy() {
    // this.appSearchSlidesData = Object.assign([], this.appSlidesData);
  }

  searchTerm(searchValue: string): void {

    if (!searchValue || searchValue === '') {
      this.appSearchSlidesData = [];
    } else {

      this.appSearchSlidesData = Object.assign([], this.appSlidesData).filter(
        item => item.SlideDescription.toLowerCase().indexOf(searchValue.toLowerCase()) > -1
      )
    } // when nothing has typed
  }

  theme(): void {
    if (this.postItListTheme == 'post-it-list-theme') {
      this.postItListTheme = 'post-it-list'
    } else {
      this.postItListTheme = 'post-it-list-theme'
    }
    localStorage.setItem(this.projectName + '_post-it-list-theme', this.postItListTheme);
    let audio = new Audio();
    audio.src = "assets/sound/tap.wav";
    audio.volume = 0.02;
    audio.load();
    audio.play();
  }

  toggleNamebox() {
    // this.namesBoxIndex = parseInt(localStorage.getItem('namesBoxIndex'));
    if (this.namesBoxIndex === 0) {
      this.namesBoxIndex++;
      this.onInputChange(52);
    } else if (this.namesBoxIndex === 1) {
      this.namesBoxIndex++;
      this.onInputChange(30);
    } else {
      this.namesBoxIndex = 1;
      this.onInputChange(52);
    }
  }



  onInputChange(value: number) {
    // console.log("This is emitted as the thumb slides");
    // console.log(value);
    if (value > 51) {
      this.myMaxWith = '935px';
      this.myMaxRWith = '300px';
      this.myMaxRightWith = '-1px';
      this.nameBox = false;
      this.nameBoxB = false;
      this.isScreenButton = false;
    } else if (value <= 51 && value > 25) {
      this.myMaxWith = '925px';
      this.myMaxRWith = '340px';
      this.myMaxRightWith = '8px';
      this.nameBox = true;
      this.nameBoxB = true;
      this.isScreenButton = true;
    } else if (value <= 25) {
      this.myMaxWith = '335px';
      this.myMaxRWith = '636px';
      this.myMaxRightWith = '352px';
      this.nameBox = true;
      this.nameBoxB = false;
      this.isScreenButton = true;
    }
    localStorage.setItem(this.projectName + '_namesBoxIndex', this.namesBoxIndexValue.toString());
  }


  screenNames() {
    this.isScreeningNames = !this.isScreeningNames;
  }

  toogleMenus() {
    this.mainMenu = !this.mainMenu;
  }

  openFullscreen() {
    this.elem = document.documentElement;
    this.isFullscreen = !this.isFullscreen;
    if (this.isFullscreen) {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        /* Firefox */
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        /* IE/Edge */
        this.elem.msRequestFullscreen();
      }
    }
    else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      }
      else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }

  }


  setFontSize() {
    // console.log(this.font_size);
    this.font_size_text = this.font_size + 'px !important';

    localStorage.setItem(this.projectName + '_font_size_text', this.font_size_text);
    localStorage.setItem(this.projectName + '_font_size', this.font_size);
  }

  // ---------------- PDF Invisible Mode (OCR text layer) ----------------

  /** Detects when the visible slide changes and auto-applies the OCR text layer. */
  ngDoCheck(): void {
    if (this.slideBackground !== this.lastSlideBackgroundForOcr) {
      this.lastSlideBackgroundForOcr = this.slideBackground;
      this.refreshSlideTextLayer();
    }
  }

  /** Clears the previous layer and (re)runs OCR for the currently shown slide. */
  private refreshSlideTextLayer(): void {
    this.resetTextLayer();
    if (!this.pdfInvisibleMode || this.createPostIt) {
      return; // disabled, or showing the post-it editor instead of a slide
    }
    const file = this.extractSlideFile(this.slideBackground);
    if (!file) {
      return;
    }
    void this.runPdfInvisible(file, this.OCR_IMAGE_BASE + file);
  }

  /** Pulls the SlideBGFileName out of `url(http://www.bipresents.com/<file>)`. */
  private extractSlideFile(background: string): string {
    const match = /url\((.*)\)/.exec(background || '');
    if (!match) {
      return '';
    }
    const url = match[1].replace(/^["']|["']$/g, '').trim();
    const marker = 'bipresents.com/';
    const idx = url.indexOf(marker);
    return idx >= 0 ? url.slice(idx + marker.length) : '';
  }

  /**
   * Runs OCR for a slide image and builds the invisible, selectable text layer:
   * per-line block elements (so a copy keeps line breaks) with per-word spans;
   * scaleX is measured in the DOM afterwards (ngAfterViewChecked).
   */
  private async runPdfInvisible(cacheKey: string, imageUrl: string): Promise<void> {
    const requestId = ++this.pdfRequestId;
    this.pdfLines = [];
    this.pdfFlatWords = [];

    try {
      const layout = await this.slideText.extractLayout(cacheKey, imageUrl);

      // Stale guard: ignore if the user navigated to another slide meanwhile.
      if (requestId !== this.pdfRequestId || this.extractSlideFile(this.slideBackground) !== cacheKey) {
        return;
      }

      const naturalWidth = layout.naturalWidth || 1;
      const naturalHeight = layout.naturalHeight || 1;
      const flat: PdfInvWord[] = [];

      this.pdfLines = layout.lines
        .filter((ln) => ln.words.some((w) => (w.text ?? '').trim().length > 0))
        .map((ln) => {
          const fontPx = Math.max(6, ((ln.y1 - ln.y0) / naturalHeight) * this.PDF_LAYER_HEIGHT_PX);
          const words = ln.words
            .filter((w) => (w.text ?? '').trim().length > 0)
            .map((w) => {
              const word: PdfInvWord = {
                text: w.text + ' ', // trailing space → native copy keeps word separation
                leftPct: (w.x0 / naturalWidth) * 100,
                topPct: (w.y0 / naturalHeight) * 100,
                targetWidthFrac: (w.x1 - w.x0) / naturalWidth,
                baseWidthPx: 0,
              };
              flat.push(word);
              return word;
            });
          return { fontPx, words };
        });

      this.pdfFlatWords = flat;
      this.pdfNeedsMeasure = true;
      this.cdr.detectChanges(); // render spans so ngAfterViewChecked can measure
    } catch (error) {
      // Graceful degrade: slide stays image-only (no selectable text).
      console.warn('PDF Invisible Mode: OCR failed for this slide.', error);
    }
  }

  ngAfterViewChecked(): void {
    if (!this.pdfNeedsMeasure || !this.pdfInvisibleMode) {
      return;
    }
    const layer = this.pdfLayerRef?.nativeElement;
    const spans = this.iwordRefs?.toArray() ?? [];
    if (!layer || spans.length === 0 || spans.length !== this.pdfFlatWords.length) {
      return; // view not fully rendered yet
    }
    this.applyScaleX(layer, spans, true);
    this.pdfNeedsMeasure = false;
    this.ensurePdfResizeObserver(layer);
  }

  ngOnDestroy(): void {
    this.pdfResizeObs?.disconnect();
    this.pdfResizeObs = null;
  }

  /** Sets each word's scaleX so its box matches the OCR bbox width. */
  private applyScaleX(layer: HTMLElement, spans: ElementRef<HTMLElement>[], remeasureBase: boolean): void {
    const layerWidth = layer.getBoundingClientRect().width || 1;
    for (let i = 0; i < spans.length; i++) {
      const el = spans[i].nativeElement;
      const word = this.pdfFlatWords[i];
      if (remeasureBase) {
        el.style.transform = 'none';
        word.baseWidthPx = el.getBoundingClientRect().width || 1;
      }
      const targetPx = word.targetWidthFrac * layerWidth;
      const scale = this.clampScale(targetPx / (word.baseWidthPx || 1));
      el.style.transformOrigin = '0 50%';
      el.style.transform = `scaleX(${scale})`;
    }
  }

  /** Recomputes scaleX on resize from cached base widths (no DOM re-measure). */
  private ensurePdfResizeObserver(layer: HTMLElement): void {
    if (this.pdfResizeObs) {
      return;
    }
    this.pdfResizeObs = new ResizeObserver(() => {
      const currentLayer = this.pdfLayerRef?.nativeElement;
      const spans = this.iwordRefs?.toArray() ?? [];
      if (currentLayer && spans.length > 0 && spans.length === this.pdfFlatWords.length) {
        this.applyScaleX(currentLayer, spans, false);
      }
    });
    this.pdfResizeObs.observe(layer);
  }

  private clampScale(value: number): number {
    if (!isFinite(value) || value <= 0) {
      return 1;
    }
    return Math.min(8, Math.max(0.1, value));
  }

  private resetTextLayer(): void {
    this.pdfLines = [];
    this.pdfFlatWords = [];
    this.pdfNeedsMeasure = false;
    this.pdfResizeObs?.disconnect();
    this.pdfResizeObs = null;
  }

}



import { MatSliderChange } from '@angular/material/slider';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, forkJoin, map } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { error } from 'console';
// import { ThrowStmt } from '@angular/compiler/src/output/output_ast';
// import { DragulaService } from 'ng2-dragula';

// CKEDITOR WYSIWYG // **************************************************************************************************

export interface DialogData {
  nameId: any;
  name: any;
}


export interface PeriodicElement {
  synonyms: string;
  position: number;
  weight: number;
  symbol: string;
}




// POST EDITOR COMPONENT

@Component({
    selector: 'editPost',
    templateUrl: 'editPost-it.html',
    styleUrls: ['./bsr.component.scss'],
    standalone: false
})
export class editPost {

  ckconfig: any;
  synonyms: any;
  loginForm: UntypedFormGroup;
  isDeleting = false;
  isDeletingName = false;
  dataEditor = '<p>Hello, world!</p>';
  infoMessage = true;
  popupwindowData: { form: UntypedFormGroup; oldValue: string; };
  title: string;
  editName: string;
  concept: any;
  projectId = '';
  // projectId = 'rg2327';
  public model = {
    editorData: '',
    namesData: ''
  };
  editorConfig: any
  newNamesPerConcept = ''
  conceptid = ''

  isMobileInfo: boolean;
  allComplete: boolean;
  isSynonymBox = false;
  isEmojiTime: boolean = false;


  displayedColumns: string[] = ['name', 'weight'];
  synonymWord: string = ' Copy name to clipboard ';
  dataSource = new BehaviorSubject<any[]>([]);
  public myAngularxQrCode: string = null;
  isQRcode: boolean;
  nameid: any = '';
  showQrCode = false
  projectName = ''

  closeQrCodePopup() {
    this.showQrCode = !this.showQrCode;
  }
  onQrCodeClose() {
    this.showQrCode = false;
  }
  openCorpwebsite() {
    window.open(this.myAngularxQrCode, '_blank');
  }
  constructor(
    public dialogRef: MatDialogRef<editPost>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private _BsrService: BsrService, private activatedRoute: ActivatedRoute, private cdr: ChangeDetectorRef, public _snackBar: MatSnackBar) {
    this.editName = this.data.nameId;
    this.dataEditor = this.data.name.html;
    this.model.editorData = this.data.name.html;
    this.title = this.data.name.Name;
    this.editorConfig = {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],

        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
        [{ 'direction': 'rtl' }],                         // text direction

        [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        [{ 'font': [] }],
        [{ 'align': [] }],

        ['clean']                                         // remove formatting button
      ]
    };
    if (this.data.name.names) {
      this.data.name.names.forEach(newName => {
        this.newNamesPerConcept += newName.name + '\n';
        this.nameid += newName.nameid + '\n';

      });
    }

    this.conceptid = this.data.name.conceptid;

    this.projectId = '';
    this.projectName = this._BsrService.getProjectName()    // assign a value
    // this.myAngularxQrCode = 'http://www.bipresents.com/'+ this.projectId;
    this.myAngularxQrCode = ' www.mynamepage.com/' + localStorage.getItem(this._BsrService.getProjectName() + '_projectName');
    if (this.data.name.Name) {
      this.concept = this.data.name.Name;
    } else {
      this.concept = this.data.name.concept;
      this.isDeletingName = true;
    }
    if (this.data.nameId === 'delete') {
      this.infoMessage = true;
      this.isDeleting = false;
      // this.isDeletingName = false;
    } else if (this.data.nameId === 'edit') {
      this.infoMessage = false;
      this.isDeleting = false;
    }
    else {
      this.infoMessage = true;
      this.isDeleting = false;
    }
    if (this.data.name === 'mobileInfo') {
      this.infoMessage = false;
      this.isDeleting = false;
      this.isMobileInfo = true;
    }
    if (this.data.name === 'qr_code') {
      this.infoMessage = false;
      this.isDeleting = false;
      this.isMobileInfo = false;
      this.isQRcode = true;
    }
    this.ckconfig = {
      allowedContent: false,
      width: '99.6%',
      contentsCss: ["body {font-size: 24px;}"],
      height: 380,
      forcePasteAsPlainText: true,
      toolbarLocation: 'top',
      toolbarGroups: [
        { name: 'clipboard', groups: ['clipboard', ''] },
        { name: 'insert' },
        { name: 'forms' },
        { name: 'tools' },
        { name: 'document', groups: ['mode', 'document', 'doctools'] },
        { name: 'others' },
        { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
        { name: 'colors' },
        { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi'] },
        { name: 'styles' },
        { name: 'links' },
        { name: 'about' }
      ],
      addPlugins: 'simplebox,tabletools',
      removePlugins: 'horizontalrule,specialchar,about,others',
      removeButtons: 'Smiley,tableselection,Image,Superscript,Subscript,Save,NewPage,Preview,Print,Templates,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,Find,Select,Button,ImageButton,HiddenField,CopyFormatting,CreateDiv,BidiLtr,BidiRtl,Language,Flash,PageBreak,Iframe,ShowBlocks,Cut,Copy,Paste,Table,Format,Source,Maximize,Styles,Anchor,SpecialChar,PasteFromWord,PasteText,Scayt,RemoveFormat,Indent,Outdent,Blockquote'

    }
    this.loginForm = new FormGroup({
      rationale: new FormControl(""),
      suma: new FormControl(""),
      name: new FormControl(this.concept)
    });
  } 

  buttonOption(option) {
    if (option === 'savePost' && this.infoMessage){
      this.dialogRef.close({ option: 'cancel' });
    } else if (option === 'delete') {
      this.isDeleting = false;
      this.dialogRef.close({ option: 'delete' });
    } else if (option === 'savePost' && !this.infoMessage) {
      this.isDeleting = false;
      const editorData = this.model.editorData && this.model.editorData.trim() ? this.model.editorData : '';
      
      const itemModified = {
        concept: this.loginForm.value.name.replace(/'/g, "`"),
        conceptid: this.data.name.conceptid,
        conceptorder: this.data.name.conceptorder,
        attributes: this.data.name.attributes,
        names: this.loginForm.value.suma.split("\n").filter(name => name.trim() !== '') || [],
        html: editorData,
      };

      if (this.loginForm.dirty || editorData !== this.data.name.html) {
        this.projectId = localStorage.getItem(this._BsrService.getProjectName() + '_projectId');
      
        const newConcepData = {
          projectId: this.projectId,
          concept: this.loginForm.value.name.replace(/'/g, "`"),
          conceptid: JSON.stringify(this.data.name.conceptid),
          attributesArray: this.data.name.attributes,
          namesArray: this.model.namesData ? this.model.namesData.split("\n").filter(name => name.trim() !== '') : [''],
          conceptHtml: editorData,
        };

        const userName = localStorage.getItem('userName')
        this._BsrService.updatePost(JSON.stringify(newConcepData), userName).subscribe({
          next: (response: any) => {          
            this.dialogRef.close({ option: 'savePost', item: itemModified }); 
          },
          error: (error) => {

            this._snackBar.open('cant save post', 'Error', {
              duration: 5000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ["error-snackbar"]
            });
            this.dialogRef.close({ option: 'cancel' });
          }
        });
      } else {
        this.dialogRef.close({ option: 'cancel' });
      }
    } else if (option === 'deleteName') {
      this.isDeleting = false;
      this._BsrService.deleteName(this.data.name.NameId).subscribe(arg => { });
      this.dialogRef.close({ option: 'deleteName' });
    } else {
      this.dialogRef.close({ option: 'cancel' });
    } 

    if (!this.nameid) {
      this.nameid = ''
    }
    if (this.newNamesPerConcept ) {
      const newNames = this.newNamesPerConcept.split('\n').filter(name => name.trim() !== '');
      const nameIds = this.nameid.split('\n');
      newNames.forEach((element, index) => {
        const tempArray = this.nameid.split('\n');
        const nameId = tempArray[index] ? tempArray[index] : '0';
        if (nameId) {
          const userName = localStorage.getItem('userName')
          this._BsrService.sendNewName(element, userName, false, this.conceptid, nameId).subscribe({
            next: (response: any) => { console.log("newName saved") },
            error: (error) => { console.log("cant save new name") },
          });
        }
      });

    }
  }
  onNoClick(): void {
    this.popupwindowData = {
      form: this.loginForm,
      oldValue: this.data.name
    }
    this.dialogRef.close(this.popupwindowData);
  }
  async getSynonyms(synonyms: any) {
    const regex = /<p>(.*?)<\/p>/g;
    const result = [];
    let match;

    while ((match = regex.exec(synonyms)) !== null) {

      const tempElement = document.createElement('div');
      tempElement.innerHTML = match[1];
      result.push(tempElement.textContent || tempElement.innerText || '');
    }

    this.synonymWord = result.join(', ');
    this.isSynonymBox = true;

    const requests = result.map(element =>
      this._BsrService.getSinonyms(element).pipe(
        map((res: any) => {
          let parsedRes;
          if (res && typeof res === 'string') {
            parsedRes = JSON.parse(res);
          } else {
            parsedRes=res;
          }
          return { word: element, synonyms: parsedRes };
        })
      )
    );

    forkJoin(requests).subscribe((results: any[]) => {
      const data: any[] = [];
      results.forEach((res, index) => {
        const word = res.word;
        const synonyms = res.synonyms.map((synonym: any) => synonym.word);
        data.push({ word, synonyms });
      });
      this.dataSource.next(data);
      this.cdr.markForCheck();
    });
  }
  setAll(evt) {
    this.model.editorData = this.model.editorData.concat('<p>' + evt + '</p>');
  }

  addSynonymsToEditor(synonyms) {
    synonyms.forEach(synonym => {
      this.model.editorData += `<p>${synonym}</p>`;
    });
    this.model.editorData = this.model.editorData.replace(/null/g, '');

    this.isSynonymBox = false
  }
  emojiToggle() {
    this.isEmojiTime = !this.isEmojiTime;
  }



}
function toTop(nameid: any) {
  throw new Error('Function not implemented.');
}

